<template>
  <generic-modal
    size="large"
    :title="$t('log')"
    icon="eye"
    image="/images/icons/log.png"
    v-on:destroy="destroy"
    :show_ok="false"
    :scrolling="true"
  >
    <div class="description">
      <div class="ui mini statistics">
        <div class="statistic">
          <div class="value">
            {{
              log_in.request_date
                | formatDate(enterprise_setup.second_detailed_date_format)
            }}
          </div>
          <div class="label">{{ $t("request date") }}</div>
        </div>
        <div class="statistic">
          <div class="value">
            {{
              log_in.response_date
                | formatDate(enterprise_setup.second_detailed_date_format)
            }}
          </div>
          <div class="label">{{ $t("response date") }}</div>
        </div>
      </div>
      <div class="ui two item top attached tabular menu">
        <a class="active item" data-tab="request">{{ $t("request") }}</a>
        <a class="item" data-tab="response">{{ $t("response") }}</a>
      </div>
      <div class="ui bottom attached active tab segment" data-tab="request">
        <editor
          @init="init_code('json')"
          v-model="request"
          lang="json"
          theme="monokai"
        ></editor>
      </div>
      <div class="ui bottom attached tab segment" data-tab="response">
        <editor
          @init="init_code('json')"
          v-model="response"
          lang="json"
          theme="monokai"
        ></editor>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import GenericModal from "@/components/GenericModal";
import filters from "@/filters";
import { enterprise_setup } from "@/utils";
import Editor from "vue2-ace-editor";
import { isEmpty } from "lodash";

export default {
  name: "APIManagerEndpointModal",
  filters: filters,
  components: {
    "generic-modal": GenericModal,
    Editor,
  },
  props: {
    log_in: Object,
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  data() {
    return {
      request: "",
      response: "",
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    init_code(type) {
      require(`brace/mode/${type}`);
      require("brace/theme/monokai");
    },
  },
  mounted() {
    window.jQuery(".ui.menu .item").tab();
  },
  beforeMount() {
    if (!isEmpty(this.log_in)) {
      this.request = JSON.stringify(this.log_in.request_data, null, 2);
      this.response = JSON.stringify(this.log_in.response_data, null, 2);
    }
  },
  watch: {},
  updated: function() {},
};
</script>
